// Customer Redux Slice

import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { customerApi } from '../../api/customerApi';

const getErrorMessage = (error, fallback) => {
  const data = error.response?.data;
  return data?.detail || data?.message || fallback;
};

export const fetchCustomers = createAsyncThunk(
  'customers/fetchAll',
  async (_, { rejectWithValue }) => {
    try {
      const response = await customerApi.getList();
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to load customers'));
    }
  }
);

export const fetchCustomerDetail = createAsyncThunk(
  'customers/fetchDetail',
  async (id, { rejectWithValue }) => {
    try {
      const response = await customerApi.getDetail(id);
      return response.data;
    } catch (error) {
      return rejectWithValue(getErrorMessage(error, 'Failed to load customer details'));
    }
  }
);

const customerSlice = createSlice({
  name: 'customers',
  initialState: {
    list: [],
    total: 0,
    loading: false,
    error: null,
    detail: null,
    detailLoading: false,
    detailError: null,
  },
  reducers: {
    clearCustomerDetail: (state) => {
      state.detail = null;
      state.detailError = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchCustomers.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCustomers.fulfilled, (state, { payload }) => {
        state.loading = false;
        state.list = payload.customers ?? [];
        state.total = payload.total ?? state.list.length;
      })
      .addCase(fetchCustomers.rejected, (state, { payload }) => {
        state.loading = false;
        state.error = payload;
      })
      .addCase(fetchCustomerDetail.pending, (state) => {
        state.detailLoading = true;
        state.detailError = null;
        state.detail = null;
      })
      .addCase(fetchCustomerDetail.fulfilled, (state, { payload }) => {
        state.detailLoading = false;
        state.detail = payload;
      })
      .addCase(fetchCustomerDetail.rejected, (state, { payload }) => {
        state.detailLoading = false;
        state.detailError = payload;
      });
  },
});

export const { clearCustomerDetail } = customerSlice.actions;
export default customerSlice.reducer;
